export enum InvitationStatus {
	Processed = 'Processed',
	Accepted = 'Accepted',
	Refused = 'Refused',
	Expired = 'Expired',
}
